// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__8IOzF","cover":"loading_cover__nL6Bb"};